import React, { useState } from "react";
import "./AddGroupModal.css";
import { IoCloseOutline } from "react-icons/io5";
import { TbStack2 } from "react-icons/tb";
import { useLanguage } from "../../../../LanguageProvider";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { useToaster } from "../../../../ToasterProvider";

export default function AddGroupModal({ isOpen, onClose, onCreate }) {
  const { getTranslation } = useLanguage();
  const { toastWarning } = useToaster();
  const [groupTitle, setgroupTitle] = useState("");

  if (!isOpen) return null;

  const handleCreate = () => {
    if (groupTitle.trim() === "") {
      toastWarning(getTranslation("groupNameCantBeEmpty"));
      return;
    }
    onCreate(groupTitle);
    onClose();
    setgroupTitle("");
  };

  return (
    <div className="add-group-modal-overlay">
      <div className="add-group-modal-container">
        <IoCloseOutline
          className="add-group-modal-button close"
          onClick={onClose}
        />

        <p className="add-group-modal-title">{getTranslation("addNewGroup")}</p>

        <AddModalInputField
          icon={<TbStack2 size={22} style={{ width: "25px" }} />}
          placeholder={getTranslation("enterGroupTitle") + "*"}
          value={groupTitle}
          onChange={(e) => setgroupTitle(e.target.value)}
          type={"text"}
        />

        <div className="add-group-modal-actions">
          <button
            className="add-group-modal-button create"
            onClick={handleCreate}
          >
            {getTranslation("create")}
          </button>
        </div>
      </div>
    </div>
  );
}
